import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setComplicationsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getComplicationsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const medicationAdministeredService = new OptionsService(serviceId)
  try {
    const complicationsResponse: IOptionsResponse = yield call([
      medicationAdministeredService,
      medicationAdministeredService.getComplicationsOptions,
    ])
    const { entity } = complicationsResponse
    yield put(setComplicationsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getComplicationsOptions() error: ${e}`))
  }
}

export function* getComplicationsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getComplicationsOptions)
}
